
      import Cooperation from './cooperation.vue'
      import type { App, Plugin } from 'vue'

      export const CooperationPlugin: Plugin = {
        install(app: App) {
          app.component('Cooperation', Cooperation)
        },
      }
      export { Cooperation }
      